import React from 'react';
import Icon from '../atoms/Icon';

function CheckmarkBadgeIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 31 32">
      <g
        fill='currentColor'
        fillRule='evenodd'
      >
        <path d="M22.8026 12.8936L21.1299 11.2209L13.6626 18.6883L9.77953 14.8052L8.10684 16.4779L13.6626 22.0336L22.8026 12.8936Z" />
        <path d="M19.1713 3.82586L24.6213 3.05579L25.5711 8.47546L30.433 11.0564L28.0155 16L30.433 20.9436L25.5711 23.5234L24.6213 28.9442L19.1713 28.173L15.2171 32L11.2606 28.173L5.81171 28.9442L4.86079 23.5234L0 20.9436L2.41639 16L0 11.0564L4.86079 8.47546L5.81171 3.05579L11.2606 3.82586L15.2171 0L19.1713 3.82586ZM12.0831 6.3566L7.76489 5.74521L7.01349 10.0389L3.16196 12.0831L5.07664 16L3.16196 19.9157L7.01349 21.9611L7.76489 26.2536L12.0831 25.6434L15.2159 28.6747L18.3499 25.6434L22.667 26.2536L23.4195 21.9611L27.2699 19.9157L25.6131 16.525L25.3575 16L25.6131 15.475L27.2699 12.0831L23.4195 10.0389L22.667 5.74521L18.3499 6.3566L15.2159 3.32414L12.0831 6.3566Z" />
      </g>
    </Icon>
  );
}

export default React.forwardRef(CheckmarkBadgeIcon);
